module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';

	Object.defineProperty(exports, "__esModule", {
	  value: true
	});

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

	var _events = __webpack_require__(1);

	var _events2 = _interopRequireDefault(_events);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var keybase = Date.now();
	function keygen(maps) {
	  var key = void 0;
	  do {
	    key = 'i18n-' + (keybase++).toString(36);
	  } while (key in maps);
	  return key;
	}

	var DocItem = function () {
	  function DocItem(parent, doc, unInitial) {
	    _classCallCheck(this, DocItem);

	    this.parent = parent;
	    this.doc = _extends({
	      type: 'i18n'
	    }, doc);
	    delete this.doc.use;
	    this.emitter = new _events2.default();
	    this.inited = unInitial !== true;
	  }

	  DocItem.prototype.getKey = function getKey() {
	    return this.doc.key;
	  };

	  DocItem.prototype.getDoc = function getDoc(lang) {
	    if (lang) {
	      return this.doc[lang];
	    }
	    return this.doc;
	  };

	  DocItem.prototype.setDoc = function setDoc(doc, lang, initial) {
	    if (lang) {
	      this.doc[lang] = doc;
	    } else {
	      this.doc = _extends({}, this.doc, doc);
	      delete this.doc.use;
	    }
	    this.emitter.emit('change', this.doc);

	    if (initial) {
	      this.inited = true;
	    } else if (this.inited) {
	      this.parent._saveChange(this.doc.key, this.doc);
	    }
	  };

	  DocItem.prototype.remove = function remove() {
	    if (!this.inited) return Promise.reject('not initialized');

	    var _doc = this.doc,
	        key = _doc.key,
	        doc = _objectWithoutProperties(_doc, ['key']); // eslint-disable-line


	    this.emitter.emit('change', doc);
	    return this.parent.remove(this.getKey());
	  };

	  DocItem.prototype.onChange = function onChange(func) {
	    var _this = this;

	    this.emitter.on('change', func);
	    return function () {
	      _this.emitter.removeListener('change', func);
	    };
	  };

	  return DocItem;
	}();

	var I18nUtil = function () {
	  function I18nUtil() {
	    _classCallCheck(this, I18nUtil);

	    this.emitter = new _events2.default();
	    // original data source from remote
	    this.i18nData = {};
	    // current i18n records on the left pane
	    this.items = [];
	    this.maps = {};
	    // full list of i18n records for synchronized call
	    this.fullList = [];
	    this.fullMap = {};

	    this.config = {};
	    this.ready = false;
	  }

	  I18nUtil.prototype._prepareItems = function _prepareItems(items) {
	    var _this2 = this;

	    var isFull = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    var isSilent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

	    this[isFull ? 'fullList' : 'items'] = items.map(function (dict) {
	      var item = _this2[isFull ? 'fullMap' : 'maps'][dict.key];
	      if (item) {
	        item.setDoc(dict, null, true);
	      } else {
	        item = new DocItem(_this2, dict);
	        _this2[isFull ? 'fullMap' : 'maps'][dict.key] = item;
	      }
	      return item;
	    });

	    if (this.ready && !isSilent) {
	      this.emitter.emit('rowschange');
	      this.emitter.emit('change');
	    } else {
	      this.ready = true;
	      this.emitter.emit('ready');
	    }
	  };

	  I18nUtil.prototype._load = function _load() {
	    var _this3 = this;

	    var configs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var silent = arguments[1];

	    if (!this.config.loader) {
	      console.error(new Error('Please load loader while init I18nUtil.'));
	      return Promise.reject();
	    }

	    return this.config.loader(configs).then(function (data) {
	      _this3._prepareItems(data.data, configs.isFull, silent);
	      // set pagination data to i18nData
	      _this3.i18nData = data;
	      if (!silent) {
	        _this3.emitter.emit('rowschange');
	        _this3.emitter.emit('change');
	      }
	      return Promise.resolve(_this3.items.map(function (i) {
	        return i.getDoc();
	      }));
	    });
	  };

	  I18nUtil.prototype._saveToItems = function _saveToItems(key, dict) {
	    var item = null;
	    item = this.items.find(function (doc) {
	      return doc.getKey() === key;
	    });
	    if (!item) {
	      item = this.fullList.find(function (doc) {
	        return doc.getKey() === key;
	      });
	    }

	    if (item) {
	      item.setDoc(dict);
	    } else {
	      item = new DocItem(this, _extends({
	        key: key
	      }, dict));
	      this.items.unshift(item);
	      this.fullList.unshift(item);
	      this.maps[key] = item;
	      this.fullMap[key] = item;
	      this._saveChange(key, dict, true);
	    }
	  };

	  I18nUtil.prototype._saveChange = function _saveChange(key, dict, rowschange) {
	    if (rowschange) {
	      this.emitter.emit('rowschange');
	    }
	    this.emitter.emit('change');
	    if (dict === null) {
	      delete this.maps[key];
	      delete this.fullMap[key];
	    }
	    return this._save(key, dict);
	  };

	  I18nUtil.prototype._save = function _save(key, dict) {
	    var saver = dict === null ? this.config.remover : this.config.saver;
	    if (!saver) return Promise.reject('Saver function is not set');
	    return saver(key, dict);
	  };

	  I18nUtil.prototype.init = function init(config) {
	    this.config = config || {};
	    if (this.config.items) {
	      // inject to current page
	      this._prepareItems(this.config.items);
	    }
	    this._load();
	    this._load({ isFull: true });
	  };

	  I18nUtil.prototype.isReady = function isReady() {
	    return this.ready;
	  };

	  // add events updater when i18n record change
	  // we should notify engine's view to change


	  I18nUtil.prototype.attach = function attach(prop, value, updator) {
	    var isI18nValue = value && value.type === 'i18n' && value.key;
	    var key = isI18nValue ? value.key : null;
	    if (prop.i18nLink) {
	      if (isI18nValue && key === prop.i18nLink.key) {
	        return prop.i18nLink;
	      }
	      prop.i18nLink.detach();
	    }

	    if (isI18nValue) {
	      return {
	        key: key,
	        detach: this.getItem(key, value).onChange(updator)
	      };
	    }

	    return null;
	  };

	  /**
	   * 搜索 i18n 词条
	   *
	   * @param {any} keyword 搜索关键字
	   * @param {boolean} [silent=false] 是否刷新左侧的 i18n 数据
	   * @returns
	   *
	   * @memberof I18nUtil
	   */


	  I18nUtil.prototype.search = function search(keyword) {
	    var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

	    return this._load({ keyword: keyword }, silent);
	  };

	  I18nUtil.prototype.load = function load() {
	    var configs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	    return this._load(configs);
	  };

	  I18nUtil.prototype.get = function get(key, lang) {
	    var item = this.getItem(key);
	    if (item) {
	      return item.getDoc(lang);
	    }
	    return null;
	  };

	  I18nUtil.prototype.getItem = function getItem(key, forceData) {
	    if (forceData && !this.maps[key] && !this.fullList[key]) {
	      var item = new DocItem(this, _extends({
	        key: key
	      }, forceData), true);
	      this.maps[key] = item;
	      this.fullMap[key] = item;
	      this.fullList.push(item);
	      this.items.push(item);
	    }
	    return this.maps[key] || this.fullMap[key];
	  };

	  I18nUtil.prototype.getItems = function getItems() {
	    return this.items;
	  };

	  I18nUtil.prototype.update = function update(key, doc, lang) {
	    var dict = this.get(key) || {};
	    if (!lang) {
	      dict = doc;
	    } else {
	      dict[lang] = doc;
	    }
	    this._saveToItems(key, dict);
	  };

	  I18nUtil.prototype.create = function create(doc, lang) {
	    var dict = lang ? _defineProperty({}, lang, doc) : doc;
	    var key = keygen(this.fullMap);
	    this._saveToItems(key, dict);
	    return key;
	  };

	  I18nUtil.prototype.remove = function remove(key) {
	    var index = this.items.findIndex(function (item) {
	      return item.getKey() === key;
	    });
	    var indexG = this.fullList.findIndex(function (item) {
	      return item.getKey() === key;
	    });
	    if (index > -1) {
	      this.items.splice(index, 1);
	    }
	    if (indexG > -1) {
	      this.fullList.splice(index, 1);
	    }
	    return this._saveChange(key, null, true);
	  };

	  I18nUtil.prototype.onReady = function onReady(func) {
	    var _this4 = this;

	    this.emitter.on('ready', func);
	    return function () {
	      _this4.emitter.removeListener('ready', func);
	    };
	  };

	  I18nUtil.prototype.onRowsChange = function onRowsChange(func) {
	    var _this5 = this;

	    this.emitter.on('rowschange', func);
	    return function () {
	      _this5.emitter.removeListener('rowschange', func);
	    };
	  };

	  I18nUtil.prototype.onChange = function onChange(func) {
	    var _this6 = this;

	    this.emitter.on('change', func);
	    return function () {
	      _this6.emitter.removeListener('change', func);
	    };
	  };

	  return I18nUtil;
	}();

	exports.default = new I18nUtil();
	module.exports = exports['default'];

/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = require("events");

/***/ }
/******/ ]);


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-i18n-util@2.0.0@@ali/ve-i18n-util/build/index.js
// module id = 47
// module chunks = 0